/* ==========================================================================
   Mini cart (sections/mini-cart.liquid, assets/mini-cart.css). Vanilla.
   - Opens with the header's cart buttons (.minicart-btn, links to /cart:
     without JS, or on the cart page, they still go there) as a <dialog>
     (showModal: above everything, the page behind inert); closes with the
     X, Esc and the backdrop. html.mini-cart-open locks the page's scroll.
   - Always drawn in Liquid. After any cart change made by cart.api.js
     (cards, product page, quick view: they all end in
     Shopify.cartUpdateInfo), it asks for the section again
     (?sections=mini-cart). Quantity and "Quitar" call /cart/change.js with
     the line's key and get the section in the same reply.
   - cart.api.js is not touched: this file wraps three of its functions,
     loaded before it (defer):
     - Shopify.cartUpdateInfo: it still runs (the header counters), then
       the mini cart is redrawn. Its lines for the old mini cart find
       nothing and do nothing.
     - Shopify.cartPopap / Shopify.cartPopapForm (the "Agregado al
       carrito" window): with "Al agregar una pieza: Abrir el mini
       carrito", the window doesn't open and the mini cart opens instead,
       once redrawn.
   - Theme editor: selecting the section opens it, deselecting closes it.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'mini-cart';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var supported = typeof window.HTMLDialogElement === 'function';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pendingOpen = 0;
  var busy = false;
  var lastFocus = null;
  var redraw = null;

  function section() {
    return document.getElementById('MiniCart');
  }
  function dialog() {
    return document.getElementById('MiniCartDialog');
  }
  function onCartPage() {
    return document.body.classList.contains('template-cart');
  }
  function usable() {
    return supported && !!dialog() && !onCartPage();
  }

  function open() {
    var d = dialog();
    if (!d || !supported) return false;
    if (d.open) return true;
    lastFocus = document.activeElement;
    d.showModal();
    document.documentElement.classList.add('mini-cart-open');
    var close = d.querySelector('.mini-cart__close');
    if (close) close.focus({ preventScroll: true });
    void d.offsetWidth; // closed position first, then the slide
    d.classList.add('is-open');
    return true;
  }

  function close() {
    var d = dialog();
    if (!d || !d.open) return;
    d.classList.remove('is-open');
    setTimeout(function () {
      if (d.open && !d.classList.contains('is-open')) d.close();
    }, reduceMotion ? 0 : 300);
  }

  // Esc: animated like the X. 'close' (also when the browser closes it at
  // once): the cleanup. Neither event bubbles: listened in capture.
  document.addEventListener('cancel', function (event) {
    if (event.target !== dialog()) return;
    event.preventDefault();
    close();
  }, true);
  document.addEventListener('close', function (event) {
    if (event.target !== dialog()) return;
    event.target.classList.remove('is-open');
    document.documentElement.classList.remove('mini-cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }, true);

  // Replaces the count and the content with the section's fresh HTML; the
  // focus goes back to the same button (data-focus-key), or to the X
  function render(html) {
    var current = section();
    if (!html || !current) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('MiniCart');
    if (!fresh) return;
    var active = document.activeElement;
    var focusKey = active && current.contains(active) ? active.getAttribute('data-focus-key') : null;
    var hadFocus = active && current.contains(active);
    ['[data-mini-cart-count]', '[data-mini-cart-content]'].forEach(function (selector) {
      var from = fresh.querySelector(selector);
      var to = current.querySelector(selector);
      if (from && to) to.innerHTML = from.innerHTML;
    });
    current.setAttribute('data-open-on-add', fresh.getAttribute('data-open-on-add') || 'false');
    current.setAttribute('data-error-text', fresh.getAttribute('data-error-text') || '');
    if (hadFocus && !current.contains(document.activeElement)) {
      var target = null;
      if (focusKey) {
        Array.prototype.some.call(current.querySelectorAll('[data-focus-key]'), function (el) {
          if (el.getAttribute('data-focus-key') === focusKey && !el.disabled) target = el;
          return !!target;
        });
      }
      target = target || current.querySelector('.mini-cart__close');
      if (target) target.focus({ preventScroll: true });
    }
  }

  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) { if (data) render(data[SECTION]); })
      .catch(function () {});
  }

  function showError(line, message) {
    var box = line && line.querySelector('[data-mini-cart-error]');
    if (!box) return;
    box.textContent = message || (section() && section().getAttribute('data-error-text')) || '';
    box.hidden = !box.textContent;
  }

  // Quantity and "Quitar": Shopify's cart API with the line's key
  function change(line, quantity) {
    if (busy || !line || isNaN(quantity) || quantity < 0) return;
    busy = true;
    var wrap = section();
    if (wrap) wrap.classList.add('is-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: line.getAttribute('data-line-key'),
        quantity: quantity,
        sections: SECTION,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          showError(line, result.data && (result.data.description || result.data.message));
          return;
        }
        if (result.data.sections && result.data.sections[SECTION]) render(result.data.sections[SECTION]);
        else refresh();
        // The header counters (cart.api.js), without redrawing twice
        if (redraw) redraw.call(window.Shopify, result.data, '.single-cart-item-loop');
      })
      .catch(function () { showError(line, ''); })
      .then(function () {
        busy = false;
        var after = section();
        if (after) after.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    if (target.closest('.minicart-btn')) {
      if (!usable()) return; // the link goes to /cart
      event.preventDefault();
      open();
      return;
    }
    if (target.closest('[data-mini-cart-close]')) {
      close();
      return;
    }
    var button = target.closest('[data-mini-cart-qty]');
    if (button && !button.disabled) {
      change(button.closest('[data-line-key]'), parseInt(button.getAttribute('data-mini-cart-qty'), 10));
    }
  });

  // After cart.api.js: redraw after each change; open instead of the window
  if (window.Shopify && typeof Shopify.cartUpdateInfo === 'function') {
    redraw = Shopify.cartUpdateInfo;
    Shopify.cartUpdateInfo = function () {
      redraw.apply(this, arguments);
      refresh().then(function () {
        if (pendingOpen && Date.now() - pendingOpen < 10000) open();
        pendingOpen = 0;
      });
    };
    ['cartPopap', 'cartPopapForm'].forEach(function (name) {
      var original = Shopify[name];
      if (typeof original !== 'function') return;
      Shopify[name] = function () {
        var wrap = section();
        if (usable() && wrap && wrap.getAttribute('data-open-on-add') === 'true') {
          pendingOpen = Date.now();
          return;
        }
        return original.apply(this, arguments);
      };
    });
  }

  // The cart page (assets/cart-page.js) changes the cart itself and asks
  // for this section in the same request: it hands over its HTML, and the
  // cart for the header counters (cart.api.js). open(): from elsewhere
  // (the notice of cart-button.js); false when it can't (no <dialog>, the
  // cart page), so the caller follows its link to /cart
  window.MiniCart = {
    sync: function (html, cart) {
      if (html) render(html);
      if (redraw && cart) redraw.call(window.Shopify, cart, '.single-cart-item-loop');
    },
    open: function () {
      return usable() && open();
    }
  };

  // Theme editor
  document.addEventListener('shopify:section:select', function (event) {
    if (event.detail && event.detail.sectionId === SECTION) open();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.detail && event.detail.sectionId === SECTION) close();
  });
  // Redrawn while open: the new dialog starts closed, so the page unlocks
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.detail && event.detail.sectionId === SECTION) {
      document.documentElement.classList.remove('mini-cart-open');
    }
  });
})();
